import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import configureStore from 'common/redux/configureStore';
import App from './components/App';
import _debug from 'debug';
import $ from 'jquery';

const debug = _debug('app::zone');

export default function informations(zone) {
  const root = document.getElementById('species_threshold');
  if (root) {
    debug('Rendering zone species threshold', zone);

    const disabled = !!$('#species_threshold').hasClass('disabled');
    const store = configureStore();
    ReactDOM.render(
      <Provider store={store}>
        <App id={zone} disabled={disabled} />
      </Provider>,
      root
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/saas/pco/zones/informations/index.js